export const SET_SENTENCE_IDS = 'SET_SENTENCE_IDS' as const;

export type StateType = {
  sentenceIds: string[];
  checkedSencenteIds: string[];
};

type Action = {
  type: 'SET_SENTENCE_IDS';
  payload: { sentenceIds: string[]; checkedSencenteIds: string[] };
};

export const setSentenceIds = (
  sentenceIds: string[],
  checkedSencenteIds: string[]
): Action => ({
  type: SET_SENTENCE_IDS,
  payload: { sentenceIds, checkedSencenteIds },
});

export type ActionType = ReturnType<typeof setSentenceIds>;

export const initialState: StateType = {
  sentenceIds: [],
  checkedSencenteIds: [],
};

export const appReducer = (state: StateType, action: ActionType): StateType => {
  switch (action.type) {
    case SET_SENTENCE_IDS:
      return {
        ...state,
        sentenceIds: action.payload.sentenceIds,
        checkedSencenteIds: action.payload.checkedSencenteIds,
      };
    default:
      return state;
  }
};
